module.exports = __webpack_public_path__ + "img/img10.8d9b993b.png";